import { Link } from "react-router-dom"

export default function Button({
  children,
  to,
  href,
  type = "button",
  variant = "primary",
  size = "md",
  className = "",
  ...props
}) {
  const variants = {
    primary:
      "bg-gray-900 text-white hover:bg-black",

    secondary:
      "bg-blue-600 text-white hover:bg-blue-700",

    outline:
      "border border-gray-300 text-gray-900 hover:bg-gray-100",

    white:
      "bg-white text-gray-900 hover:bg-gray-100",
  }

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  }

  const classes = `
    inline-flex
    items-center
    justify-center
    gap-2
    rounded-xl
    font-semibold
    transition-all
    duration-300
    focus:outline-none
    focus:ring-2
    focus:ring-offset-2
    focus:ring-gray-900
    ${variants[variant]}
    ${sizes[size]}
    ${className}
  `

  if (to) {
    return (
      <Link
        to={to}
        className={classes}
        {...props}
      >
        {children}
      </Link>
    )
  }

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        {...props}
      >
        {children}
      </a>
    )
  }

  return (
    <button
      type={type}
      className={classes}
      {...props}
    >
      {children}
    </button>
  )
}